import styled from 'styled-components';
import { OnlineThemeType } from '../../themes/online';

const getPaymentMethodIcon = (paymentMethodType: string, theme: OnlineThemeType, input: boolean) => {
  if (paymentMethodType) {
    return `
      background-image: url(${theme.icons[paymentMethodType]});
      background-repeat: no-repeat;
      background-size: contain;
      width: 43px;
      height: 30px;

    ${
      input
        ? `position: absolute;
       top: 44px;
       right: 8px;
      `
        : ``
    }`;
  }
  return '';
};

export const SPaymentMethodIcon = styled.span<{
  paymentMethodType: string;
  input: boolean;
}>(({ theme, paymentMethodType, input }) => {
  return `
      display: inline;
      ${getPaymentMethodIcon(paymentMethodType, theme, input)}
      `;
});
